module.exports = __webpack_public_path__ + "static/media/moderatorBadge.2778c488.png";